// Import utilities
import { isEmpty } from '@automator/utilities';

/**
 * Pro label <uo-pro-tag>
 * This file creates the web component
 */
class ProTag extends HTMLElement {
	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();

		// Use Shadow DOM
		const shadowRoot = this.attachShadow( {
			mode: 'open',
		} );
	}

	/**
	 * Invoked each time the custom element is appended into a document-connected element.
	 * This will be called each time the node is moved, and may be called before the element's contents have been fully parsed.
	 */
	connectedCallback() {
		this.shadowRoot.innerHTML = `
			<style>

				:host {
					display: inline-block;
					line-height: 0;
				}
				
				div {
					background: var( --uap-color-green );

					font-size: var( --uap-font-size--body-xsmall );
					line-height: var( --uap-line-height--body-xsmall );
					font-weight: 700;
					color: #fff;

					display: inline-flex;

					border-radius: 150px;

					padding: 0 6px;
				}

				[data-color="secondary"] {
					background: var( --uap-color-gray-2 );
				}

			</style>

			<div data-color="${this.color}">
				${UncannyAutomatorBackend.i18n.proLabel.pro}
			</div>
		`;
	}

	/**
	 * Gets the color attribute of the tag.
	 * If the color attribute is not set or is empty, it defaults to 'primary'.
	 *
	 * @return {String} The color attribute value or 'primary' if not set.
	 */
	get color() {
		// Check if the user defined the style
		let tagStyle = this.getAttribute( 'color' );
		tagStyle = ! isEmpty( tagStyle ) ? tagStyle : 'primary';

		return tagStyle;
	}
}

customElements.define( 'uo-pro-tag', ProTag );
